import Vue from 'vue';
import VueAwesomeSwiper from 'vue-awesome-swiper';

// import custom style
import 'swiper/css/swiper.min.css';

Vue.use(VueAwesomeSwiper);
